import React, { FC } from 'react';
import { IoSearchOutline } from 'react-icons/io5';

import {
  ClearButton,
  InputShell,
  Label,
  SearchFieldInput,
  SearchFieldWrapper,
  SearchIcon,
} from './styled';

export interface SearchInputProps {
  label?: string;
  placeholder?: string;
  value: string;
  disabled?: boolean;
  /** Toolbar layout: no bottom margin, optional leading search icon. */
  inline?: boolean;
  showIcon?: boolean;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: string) => void;
}

export const SearchInput: FC<SearchInputProps> = ({
  label,
  placeholder,
  value,
  disabled,
  inline,
  showIcon,
  onChange,
}) => {
  const showClear = !disabled && value.length > 0;

  return (
    <SearchFieldWrapper $inline={inline}>
      {label && <Label>{label}</Label>}
      <InputShell $disabled={disabled}>
        {showIcon && (
          <SearchIcon aria-hidden>
            <IoSearchOutline size={16} />
          </SearchIcon>
        )}
        <SearchFieldInput
          type="text"
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          $hasIcon={showIcon}
          onChange={(e) => onChange(e.currentTarget.value)}
        />
        {showClear && (
          <ClearButton type="button" aria-label="Clear search" onClick={() => onChange('')}>
            ×
          </ClearButton>
        )}
      </InputShell>
    </SearchFieldWrapper>
  );
};
